/**
 * Sections du hub Administration — source unique (id + clé i18n).
 * Le panneau contextuel (Sidebar) et le contenu (AdminHubPage) en dérivent.
 */
export const ADMIN_SECTIONS = [
  // Groupe PLATEFORME : porte sur tous les clients (l'exploitant administre).
  { id: 'tenants', labelKey: 'admin:tabs.tenants', group: 'platform' },
  { id: 'users',   labelKey: 'admin:tabs.users',   group: 'platform' },
  { id: 'roles',   labelKey: 'admin:tabs.roles',   group: 'platform' },
  { id: 'design',  labelKey: 'admin:tabs.design',  group: 'platform' },
  // Comptes admin plateforme (exploitant MFP), en rouge — hors périmètre client.
  { id: 'palestre', labelKey: 'admin:tabs.palestre', group: 'platform', danger: true },
  // Groupe CLIENT, « Données clients » (2026-10-11) : UNE section, nommée dans
  // le menu par le client actif (incident 2026-08-18 : des données chargées sur
  // le mauvais client faute de voir sur qui on opérait). Elle remplace le
  // bouton Gouvernance client ; l'export et la sauvegarde ont aussi leur place
  // chez le client, Paramètres › Données.
  { id: 'client',  labelKey: 'admin:tabs.client', group: 'client' },
];

export const ADMIN_SECTION_IDS = ADMIN_SECTIONS.map((s) => s.id);
